import React, { useState } from "react";
import { Typography, Button, TextField, Box } from "@mui/material";
import ModalWrapper from "../../../components/model/Model";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";
import { toast } from "react-toastify";

interface ReNameModelProps {
    open: boolean;
    onClose: () => void;
    scanId: string;
    scanName: string;
    refetch: () => void
}

const ReNameModel: React.FC<ReNameModelProps> = ({ open, onClose, scanId, scanName, refetch }) => {
    const [newName, setNewName] = useState(scanName);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewName(event.target.value);
    };

    const isRenameDisabled = newName.trim() === "" || newName.trim() === scanName.trim();

    const handleSubmit = async () => {
        const payload = {
            scanIdNo: 1,
            scanid: scanId,
            scanname: newName
        }
        try {
            const response = await axiosInstance.post(END_POINTS.MY_SCAN_RENAME, payload)
            toast(response.data.message, { type: "success" });
            refetch()
            onClose()
        } catch (err) {
            toast.error((err as any).response?.data?.message || "An error occurred")
        }
    }

    return (
        <ModalWrapper
            open={open}
            onClose={onClose}
            header={<Typography sx={{ fontSize: '15px', fontWeight: 800 }}>Renaming the scan?</Typography>}
            body={
                <Box display="flex" flexDirection="column" gap={2} pb={3} sx={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        textAlign="center"
                        sx={{ width: "100%", maxWidth: "100%", overflow: "hidden" }}
                    >
                        <Typography sx={{ fontSize: '15px' }}>Please rename the scan name:</Typography>
                        <Typography
                            sx={{
                                fontSize: '15px',
                                wordBreak: 'break-all',
                                overflowWrap: 'anywhere',
                                maxWidth: '100%',
                            }}
                        >
                            {scanName}
                        </Typography>
                    </Box>
                    <TextField
                        label="New Name"
                        value={newName}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                </Box>
            }
            footer={
                <>
                    <Button color="primary" variant="contained" disabled={isRenameDisabled} onClick={handleSubmit} sx={{ width: 120 }}>
                        Rename
                    </Button>
                    <Button onClick={onClose} variant="outlined" sx={{ width: 120 }}>
                        Cancel
                    </Button>
                </>
            }
        />
    );
};

export default ReNameModel;
